import { crearTabla } from '@plataforma/ui';

import { obtenerMiEmpresaSuperAdmin } from '../api/backoffice.js';
import { obtenerEstadoSesion } from '../estado-sesion.js';
import { exigirSuperAdmin } from '../guardas.js';

import {
  crearBadge,
  estadoCarga,
  estadoError,
  ESTADOS_EMPRESA,
  ESTADOS_SUSCRIPCION,
  ESTADOS_TRIAL,
  fecha,
  moneda,
} from './backoffice-ui.js';
import { montarShell } from './shell.js';

export async function vistaMiEmpresa(contenedorRaiz) {
  if (!exigirSuperAdmin()) return;

  const contenido = montarShell(contenedorRaiz, '/mi-empresa');
  contenido.innerHTML = estadoCarga('Cargando mi empresa...');

  const usuarioId = obtenerEstadoSesion().sesion?.user?.id;
  if (!usuarioId) {
    contenido.innerHTML = estadoError('No se pudo identificar al usuario actual.');
    return;
  }

  const { data, error } = await obtenerMiEmpresaSuperAdmin(usuarioId);

  if (error) {
    contenido.innerHTML = estadoError('No se pudo cargar tu empresa comercial.');
    return;
  }

  if (!data?.empresa) {
    contenido.innerHTML = `
      <div class="pf-backoffice-header">
        <div>
          <h1>Mi empresa</h1>
          <p class="pf-texto-suave">Tu usuario Super Admin todavía no tiene una empresa comercial vinculada.</p>
        </div>
      </div>
      <p class="pf-backoffice-note">
        El modelo ya separa permisos administrativos globales de empresa comercial propia mediante empresa_personal_id.
      </p>
    `;
    return;
  }

  const empresa = data.empresa;

  contenido.innerHTML = `
    <div class="pf-backoffice-header">
      <div>
        <h1>Mi empresa</h1>
        <p class="pf-texto-suave">Relación comercial propia del Super Admin, separada de permisos globales.</p>
      </div>
    </div>
    <section class="pf-tarjeta pf-backoffice-card">
      <div class="pf-backoffice-detail">
        <div class="pf-backoffice-kv"><span>Empresa</span><strong>${empresa.nombre}</strong></div>
        <div class="pf-backoffice-kv"><span>Subdominio</span><strong>${empresa.subdominio}.vimosdigital.com</strong></div>
        <div class="pf-backoffice-kv"><span>Estado</span><strong id="pf-mi-estado"></strong></div>
        <div class="pf-backoffice-kv"><span>Trial</span><strong id="pf-mi-trial"></strong></div>
        <div class="pf-backoffice-kv"><span>Plan</span><strong>${empresa.plan?.nombre ?? '—'} · ${moneda(empresa.plan?.precio_mensual)}</strong></div>
        <div class="pf-backoffice-kv"><span>Creación</span><strong>${fecha(empresa.creado_en)}</strong></div>
      </div>
    </section>
    <section class="pf-tarjeta pf-backoffice-card" style="margin-top: 16px;">
      <h2>Suscripciones</h2>
      <div id="pf-mi-suscripciones" style="margin-top: 12px;"></div>
    </section>
  `;

  contenido.querySelector('#pf-mi-estado').appendChild(crearBadge(ESTADOS_EMPRESA, empresa.estado));
  contenido
    .querySelector('#pf-mi-trial')
    .appendChild(crearBadge(ESTADOS_TRIAL, empresa.trial_estado));
  contenido.querySelector('#pf-mi-suscripciones').appendChild(
    crearTabla({
      filaVacia: 'No hay suscripciones para tu empresa.',
      columnas: [
        { titulo: 'Plan', render: (fila) => fila.plan?.nombre ?? '—' },
        { titulo: 'Estado', render: (fila) => crearBadge(ESTADOS_SUSCRIPCION, fila.estado) },
        { titulo: 'Inicio', render: (fila) => fecha(fila.inicia_en) },
        { titulo: 'Fin', render: (fila) => fecha(fila.fin_en) },
      ],
      filas: data.suscripciones ?? [],
    }),
  );
}
